// History Screen - Full-Width Responsive Layout
import { useApp } from '../hooks/useApp';
import { SCREENS, ANALYSIS_TYPES } from '../config/constants';
import { Container, Text, Card, IconButton } from '../components/ui';
import Icons from '../components/Icons';
import BottomNav from '../components/BottomNav';

function HistoryScreen() {
    const { goBack, history, setCurrentScreen, setAnalysisResults } = useApp();

    const groupedHistory = history.reduce((acc, item) => {
        const date = new Date(item.date).toLocaleDateString('vi-VN');
        if (!acc[date]) acc[date] = [];
        acc[date].push(item);
        return acc;
    }, {});

    const viewResult = (item) => {
        setAnalysisResults(item);
        setCurrentScreen(SCREENS.RESULTS);
    };

    return (
        <Container className="min-h-screen bg-theme-bg pb-24" safe>
            {/* Header - Full Width */}
            <div className="header-fullwidth border-b border-theme">
                <div className="header-content">
                    <IconButton onClick={goBack}><Icons.Back /></IconButton>
                    <Text className="font-semibold sm:text-lg">Lịch sử</Text>
                    <div className="w-11" />
                </div>
            </div>

            <div className="main-content py-4 sm:py-6">
                {history.length === 0 ? (
                    <div className="flex flex-col items-center justify-center py-20 text-center">
                        <div className="w-20 h-20 bg-theme-tertiary rounded-full flex items-center justify-center mb-4 opacity-50">
                            <Icons.History />
                        </div>
                        <Text variant="h4" className="mb-2">Chưa có lịch sử</Text>
                        <Text variant="caption">Bắt đầu phân tích để xem kết quả</Text>
                    </div>
                ) : (
                    Object.entries(groupedHistory).map(([date, items]) => (
                        <div key={date} className="mb-6">
                            <Text variant="small" className="font-semibold mb-3">{date}</Text>
                            <div className="space-y-3">
                                {items.map((item) => (
                                    <Card
                                        key={item.id}
                                        className="cursor-pointer active:scale-[0.99] transition-transform"
                                        onClick={() => viewResult(item)}
                                    >
                                        <div className="flex items-center gap-4">
                                            <div className="w-14 h-14 rounded-xl bg-theme-tertiary flex items-center justify-center flex-shrink-0">
                                                <Icons.Tongue />
                                            </div>
                                            <div className="flex-1 min-w-0">
                                                <Text className="font-semibold block">
                                                    {item.type === ANALYSIS_TYPES.FULL ? 'Phân tích toàn diện' :
                                                        item.type === ANALYSIS_TYPES.TONGUE ? 'Kiểm tra lưỡi' : 'Kiểm tra mặt'}
                                                </Text>
                                                <Text variant="small" className="mt-0.5">
                                                    {new Date(item.date).toLocaleTimeString('vi-VN', { hour: '2-digit', minute: '2-digit' })}
                                                </Text>
                                            </div>
                                            <div className="text-right flex-shrink-0">
                                                <Text className={`text-2xl font-bold ${item.score >= 80 ? 'text-success' : item.score >= 60 ? 'text-warning' : 'text-danger'}`}>
                                                    {item.score}
                                                </Text>
                                                <Text variant="small">điểm</Text>
                                            </div>
                                        </div>
                                    </Card>
                                ))}
                            </div>
                        </div>
                    ))
                )}
            </div>

            <BottomNav />
        </Container>
    );
}

export default HistoryScreen;

